import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @title={{i18n "categories.reorder.title"}}
  @closeModal={{@closeModal}}
  @inline={{@inline}}
  class="reorder-categories"
>
  <:body>
    <table>
      <thead>
        <th>{{i18n "categories.category"}}</th>
        <th class="reorder-categories__header-position">
          {{i18n "categories.reorder.position"}}
        </th>
      </thead>
      <tbody>
        {{#each this.sortedEntries as |entry|}}
          <tr
            data-category-id={{entry.category.id}}
            class={{if
              (eq this.highlightedCategoryId entry.category.id)
              "highlighted"
            }}
          >
            <td>
              <div class={{concat "reorder-categories-depth-" entry.depth}}>
                {{category-badge entry.category allowUncategorized="true"}}
              </div>
            </td>

            <td>
              <div class="reorder-categories-actions">
                <input
                  {{on "change" (with-event-value (fn this.change entry))}}
                  value={{entry.position}}
                  type="number"
                  min="0"
                />
                <DButton
                  @action={{fn this.move entry -1}}
                  @icon="arrow-up"
                  class="btn-default no-text move-up"
                />
                <DButton
                  @action={{fn this.move entry 1}}
                  @icon="arrow-down"
                  class="btn-default no-text move-down"
                />
              </div>
            </td>
          </tr>
        {{/each}}
      </tbody>
    </table>
  </:body>

  <:footer>
    <DButton
      @action={{this.save}}
      @label="categories.reorder.save"
      @disabled={{not this.changed}}
      class="btn-primary"
    />
  </:footer>
</DModal>
*/
{
  "id": "4Sw5ZGXZ",
  "block": "[[[8,[39,0],[[24,0,\"reorder-categories\"]],[[\"@title\",\"@closeModal\",\"@inline\"],[[28,[37,1],[\"categories.reorder.title\"],null],[30,1],[30,2]]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[10,\"table\"],[12],[1,\"\\n      \"],[10,\"thead\"],[12],[1,\"\\n        \"],[10,\"th\"],[12],[1,[28,[35,1],[\"categories.category\"],null]],[13],[1,\"\\n        \"],[10,\"th\"],[14,0,\"reorder-categories__header-position\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"categories.reorder.position\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"sortedEntries\"]]],null]],null],null,[[[1,\"          \"],[10,\"tr\"],[15,\"data-category-id\",[30,3,[\"category\",\"id\"]]],[15,0,[52,[28,[37,5],[[30,0,[\"highlightedCategoryId\"]],[30,3,[\"category\",\"id\"]]],null],\"highlighted\"]],[12],[1,\"\\n            \"],[10,\"td\"],[12],[1,\"\\n              \"],[10,0],[15,0,[28,[37,6],[\"reorder-categories-depth-\",[30,3,[\"depth\"]]],null]],[12],[1,\"\\n                \"],[1,[28,[35,7],[[30,3,[\"category\"]]],[[\"allowUncategorized\"],[\"true\"]]]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\\n            \"],[10,\"td\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"reorder-categories-actions\"],[12],[1,\"\\n                \"],[11,\"input\"],[16,2,[30,3,[\"position\"]]],[24,\"min\",\"0\"],[24,4,\"number\"],[4,[38,8],[\"change\",[28,[37,9],[[28,[37,10],[[30,0,[\"change\"]],[30,3]],null]],null]],null],[12],[13],[1,\"\\n                \"],[8,[39,11],[[24,0,\"btn-default no-text move-up\"]],[[\"@action\",\"@icon\"],[[28,[37,10],[[30,0,[\"move\"]],[30,3],-1],null],\"arrow-up\"]],null],[1,\"\\n                \"],[8,[39,11],[[24,0,\"btn-default no-text move-down\"]],[[\"@action\",\"@icon\"],[[28,[37,10],[[30,0,[\"move\"]],[30,3],1],null],\"arrow-down\"]],null],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[3]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],[[[1,\"\\n    \"],[8,[39,11],[[24,0,\"btn-primary\"]],[[\"@action\",\"@label\",\"@disabled\"],[[30,0,[\"save\"]],\"categories.reorder.save\",[28,[37,12],[[30,0,[\"changed\"]]],null]]],null],[1,\"\\n  \"]],[]]]]]],[\"@closeModal\",\"@inline\",\"entry\"],false,[\"d-modal\",\"i18n\",\"each\",\"-track-array\",\"if\",\"eq\",\"concat\",\"category-badge\",\"on\",\"with-event-value\",\"fn\",\"d-button\",\"not\"]]",
  "moduleName": "discourse/components/modal/reorder-categories.hbs",
  "isStrictMode": false
});